import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import { useEmailFromDomainEnabledEntitlement } from '__hooks/useEmailFromDomainEnabledEntitlement';
import { BulkActionInfoWrapper, BulkActionTextWrapper } from './styles';

type IntegratedEmailWarningProps = {
  externalAccount: boolean;
  marginBottom?: boolean;
};

export const IntegratedEmailWarning = (props: IntegratedEmailWarningProps) => {
  const { externalAccount, marginBottom } = props;
  const { t } = useTranslation();
  const emailFromDomainEnabled = useEmailFromDomainEnabledEntitlement();

  return !emailFromDomainEnabled || externalAccount ? (
    <BulkActionInfoWrapper
      marginBottom={marginBottom}
      noLeftPadding
      backgroundColor="inherit"
    >
      <BulkActionTextWrapper>
        <KizenTypography
          as="span"
          fontStyle="italic"
          color="var(--color-viz-cat-7-primary)"
        >
          {t(
            'Based on your email account type you have a daily quota of emails you can send via the selected integrated inbox.'
          )}
        </KizenTypography>
      </BulkActionTextWrapper>
    </BulkActionInfoWrapper>
  ) : null;
};
